import { useQuery } from '@tanstack/react-query';
import { fetchFontFacesApi } from '../helpers/api/customizationApi';

export const FONTS_KEYS = {
  FONTFACES: 'fontfaces',
};

export const useGetFontFaces = () => {
  return useQuery([FONTS_KEYS.FONTFACES], () => fetchFontFacesApi(), {
    cacheTime: Infinity,
  });
};
